import {Race,readRecords,saveRecord} from '../core/race.js';
import {GameUI} from './ui.js';
import {Controls} from './input.js';
import {DrivingScene} from './scene.js';
export class ShiftGame {
  constructor(platform){
    this.platform=platform;this.race=new Race();this.records=readRecords(platform.storage);this.sound=true;this.haptics=true;this.message='';this.messageTime=0;this.newRecord=false;
    this.ui=new GameUI(platform);this.ui.resize(platform.size());this.controls=new Controls(this);
    this.scene=new DrivingScene(platform,this.ui.surface);this.scene.resize(platform.size(),this.ui.layout);
    this.last=null;this.hidden=false;this.fps=0;this.frames=0;this.timeSample=0;
    platform.input(e=>{this.advance(platform.now());this.controls.handle(e);this.consumeEvents();});
    platform.resize(size=>{this.race.pause();this.controls.clear();this.ui.resize(size);this.scene.resize(size,this.ui.layout);});
    platform.lifecycle(event=>{if(event==='hide'){this.hidden=true;this.race.pause();this.controls.clear();platform.sound.suspend();platform.cancelFeedback();}else{this.hidden=false;this.last=0;}});
    platform.expose(this);
  }
  unlock(){this.platform.sound.unlock();}
  isClutchDown(){return this.controls.isClutchDown();}
  clutchRect(){return this.controls.clutchRect();}
  stickPosition(){return this.controls.stickPosition();}
  action(id){
    const r=this.race;
    if(id==='sound'){this.sound=!this.sound;this.platform.sound.setEnabled(this.sound);return;}
    if(id==='haptics'){this.haptics=!this.haptics;if(!this.haptics)this.platform.cancelFeedback();return;}
    if(id.startsWith('distance:')&&r.phase==='ready'){r.reset(Number(id.split(':')[1]));return;}
    if(id==='retry'){this.controls.clear();this.message='';this.newRecord=false;r.reset();this.unlock();return;}
    if(id==='pause'){r.pause();this.controls.clear();this.platform.sound.suspend();this.platform.cancelFeedback();return;}
    if(id==='resume'){this.controls.clear();r.resume();this.unlock();return;}
    if(id==='menu'){this.controls.clear();r.reset();this.message='';return;}
    if(id==='ignite'){
      if(!this.isClutchDown()){this.showMessage('先踩住离合，再点火');return;}
      r.ignite();
    }
  }
  showMessage(message){this.message=message;this.messageTime=1.5;}
  consumeEvents(){
    const messages={shift:'已入挡 · 松开离合',grind:'先踩离合，再换挡',stall:'发动机熄火 · 踩离合点火',restart:'发动机已启动',damage:'错误降挡 · 机械超转',neutral:'空挡',armed:'踩住离合 · 到 0 松开',go:'0！松开离合起步',perfectLaunch:'Perfect Launch',launch:'已起步 · 高转速踩离合升挡',falseStart:'抢跑 · 到 0 再松离合',launchLocked:'发车保持一挡',finish:'冲线！自动刹车'};
    for(const event of this.race.drainEvents()){
      this.scene.cue(event);this.platform.sound.cue(event);this.platform.feedback(event,this.haptics);
      if(messages[event])this.showMessage(messages[event]);
      if(event==='armed'){this.newRecord=false;this.messageTime=3;}
      if(event==='finish')this.newRecord=saveRecord(this.platform.storage,this.records,this.race);
      if(event==='pause'){this.controls.clear();this.platform.sound.suspend();this.platform.cancelFeedback();}
    }
  }
  start(){this.platform.frame(t=>this.frame(t));}
  advance(now){
    const dt=this.last===null?0:Math.max(0,(now-this.last)/1000);this.last=now;
    if(this.hidden)return 0;
    if(dt>.25)this.race.pause();
    this.controls.syncClutch();this.race.tick(dt);this.consumeEvents();this.messageTime=Math.max(0,this.messageTime-dt);
    this.timeSample+=dt;
    this.platform.sound.update(this.race.vehicle,!this.race.paused&&['countdown','racing','braking'].includes(this.race.phase));
    return dt;
  }
  frame(){
    const dt=this.advance(this.platform.now());
    if(!this.hidden){
      this.ui.draw(this);this.scene.render(this.race.renderState(),Math.min(dt,.05));
      this.frames++;if(this.timeSample>1){this.fps=Math.round(this.frames/this.timeSample);this.frames=0;this.timeSample=0;}
    }
    this.platform.frame(()=>this.frame());
  }
  diagnostics(){return {platform:this.platform.name,phase:this.race.phase,paused:this.race.paused,length:this.race.length,elapsed:this.race.elapsed,result:this.race.result,countdown:this.race.countdown,launched:this.race.launched,reactionTime:this.race.reactionTime,perfectLaunch:this.race.perfectLaunch,failure:this.race.failure,vehicle:{...this.race.vehicle},records:{...this.records},fps:this.fps,audio:this.platform.sound.diagnostics(),size:this.platform.size(),layout:this.ui.layout};}
}
